import PropTypes from "prop-types";

import { BaseSaleHighlight } from "../../../components/BaseComponents/BaseSaleHighlight";
import { twMerge } from "../../../helpers/twMerge";
import { SaleHighlightStarIcon } from "../../assets/SaleHighlightStarIcon";

export const AmazonSaleHighlight = ({ className, ...props }) => {
	const currentDate = new Date();
	const formattedDate = currentDate.toLocaleString("default", {
		month: "long",
		year: "numeric",
	});

	return (
		<BaseSaleHighlight
			wrapper={twMerge(
				"tw:mb-2 tw:flex tw:w-full tw:items-center tw:justify-center tw:gap-2 tw:rounded-lg tw:bg-[#E1255B] tw:px-4 tw:py-2",
				className,
			)}
			contentWrapper="tw:text-white tw:font-semibold tw:text-lg tw:leading-6"
			icon={<SaleHighlightStarIcon className="tw:text-2xl tw:text-white" />}
			{...props}
		>
			{formattedDate} Sales
		</BaseSaleHighlight>
	);
};

AmazonSaleHighlight.propTypes = {
	className: PropTypes.string,
};
